import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gk6kg6d4dw: FaireBrandEntity = {
  token: "b_gk6kg6d4dw",
  type: "brand",
  name: "JOIA ACCESSORIES",
  avatarUrl:
    "https://cdn.faire.com/fastly/c9304de86a9813de7ee6fb86fbed3ec42a4d50e1858c587c5ad1aa1557a083ff.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5869c8a9bf674ff0efc1bc3f3bf02bf46462b66d2b94b90a9e22629d79831dc6.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c9304de86a9813de7ee6fb86fbed3ec42a4d50e1858c587c5ad1aa1557a083ff.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5869c8a9bf674ff0efc1bc3f3bf02bf46462b66d2b94b90a9e22629d79831dc6.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 132,
  isTopShop: true,
  isInsider: true,
  description:
    "Joia Accessories has been a leading provider of fashion jewelry, accessories, and a wide array of other category selections in the heart of Downtown Los Angeles Fashion District for over 30 years. \n\nWe pride ourselves on offering the largest and most diverse selection in the industry, ensuring that we meet the ever-evolving demands of fashion trends.\n\nCome visit Joia Accessories, a one stop shopping for all your needs in fashion accessories. ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:39.558Z",
    importedBy: "entity-db-cli",
  },
};
